// src/components/TeamSection.js
import React from 'react';
import poonamPhoto from '../assets/po.png';
import rishiPhoto from '../assets/ri.png';

const team = [
  {
    name: 'Poonam Kapoor',
    title: 'Chief Executive Officer',
    desc: `Poonam Kapoor brings over two decades of leadership experience in global and US-based outsourcing industries. Her expertise spans Quality Assurance, Process Optimization, Automation, and Human Resources. As CEO of MDeRCM, she leads with a focus on operational excellence and scalable team growth.`,
    photo: poonamPhoto // Imported Poonam's photo
  },
  {
    name: 'Rishi Kapoor',
    title: 'Chief Technology & Operations Officer',
    desc: `Rishi Kapoor has 20+ years of deep domain expertise in Revenue Cycle Management. Having served in various roles across leading RCM firms, he specializes in EDI, Automation, Integration, Process Transition, Marketing, Sales, Customer Support, Business Development, Accounts Receivable, Denial Management, and Compliance.`,
    photo: rishiPhoto // Imported Rishi's photo
  }
];

const getInitials = (name) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};

const TeamSection = () => {
  return (
    <section
      style={{
        padding: '80px 5%',
        background: 'linear-gradient(to right, #e0eafc, #cfdef3)',
        fontFamily: "'Poppins', sans-serif"
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          fontSize: 'clamp(28px, 5vw, 42px)',
          fontWeight: 700,
          marginBottom: '50px',
          color: '#001F2B'
        }}
      >
        Meet Our Leadership
      </h2>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '40px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}
      >
        {team.map((member, index) => (
          <div
            key={index}
            style={{
              width: '100%',
              maxWidth: '350px',
              background: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '20px',
              padding: '30px 25px',
              textAlign: 'center',
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              transition: 'transform 0.3s, box-shadow 0.3s',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              border: '1px solid rgba(255, 255, 255, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.03)';
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
            }}
          >
            {/* Photo Avatar */}
            <div
              style={{
                width: '120px',
                height: '120px',
                margin: '0 auto 20px',
                borderRadius: '50%',
                overflow: 'hidden',
                boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                border: '4px solid #F26522'
              }}
            >
              <img
                src={member.photo}
                alt={member.name}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center'
                }}
                onError={(e) => {
                  // Fallback to initials if image fails to load
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              {/* Fallback initials div */}
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#F26522',
                  color: '#fff',
                  display: 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '32px',
                  fontWeight: 600,
                  marginTop: '-120px'
                }}
              >
                {getInitials(member.name)}
              </div>
            </div>

            <h3 style={{ fontSize: '20px', fontWeight: '700', color: '#001F2B', marginBottom: '5px' }}>
              {member.name}
            </h3>
            <p style={{ fontSize: '16px', color: '#666', fontWeight: 500, marginBottom: '15px' }}>
              {member.title}
            </p>
            <p style={{ fontSize: '14.5px', color: '#444', textAlign: 'justify', lineHeight: '1.6' }}>
              {member.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;